export default __webpack_public_path__ + "static/media/top-team.bf427ed9.png";